import React from 'react';
import { DrawerContent, DrawerContentProps } from '@chakra-ui/react';

export type DrawerContainerProps = DrawerContentProps;

export const DrawerContainer: React.FC<DrawerContainerProps> = ({
  children,
  m = { base: 0, md: 6 },
  mr = { base: 0, md: 4 },
  maxH = { base: '100vh', md: 'calc(100vh - 48px)' },
  borderRadius = { base: 0, md: 'lg' },
  bg = 'surface.panel',
  ...rest
}) => {
  return (
    <DrawerContent
      m={m}
      mr={mr}
      maxH={maxH}
      borderRadius={borderRadius}
      bg={bg}
      {...rest}>
      {children}
    </DrawerContent>
  );
};
